import React from "react";
import {
	string,
	oneOfType,
	number,
	objectOf,
	object,
	shape,
	array,
	bool,
	func,
	oneOf,
} from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
// eslint-disable-next-line import/no-cycle
import { CardLink } from "../HeroCard";
import * as styles from "./SecondaryCard.module.scss";
import { Icon } from "../../Icons";

const SecondaryCard = ({
	image,
	header,
	link,
	button,
	className,
	bodyClassNames,
	style,
	horizontal,
	subheader,
}) => (
	<Card className={cx(styles.secondary, className, horizontal && styles.horizontal)} style={style}>
		{image && (
			<Card.Image
				className={cx(styles.image)}
				src={!image.srcSet ? image.src : ""}
				source={image.srcSet && image}
				alt={image.alt}
				fluid={image.fluid}
			/>
		)}
		<Card.BodyContainer className={cx(styles.contentContainer, bodyClassNames?.cardBody)}>
			{link?.to ? (
				<Card.Link className={cx(styles.link)} to={link.to} target={link.target} withoutIcon>
					<Card.Header className={cx(styles.heading)}>{header}</Card.Header>
				</Card.Link>
			) : (
				<Card.Header className={cx(styles.heading)}>{header}</Card.Header>
			)}
			{subheader && <Card.Subheader className={cx(styles.subheading)}>{subheader}</Card.Subheader>}
			{link?.to && (
				<div className={cx(styles.link)}>
					<span className={cx(styles.linkText)}>{link.text}</span>
					<Icon name="arrow-right" className={cx("swg-text-xs")} />
				</div>
			)}
			{button?.onClick && (
				<div>
					<Card.Button
						className={cx(styles.buttonLink)}
						icon={button.icon}
						iconPlacement={button.iconPlacement}
						onClick={button.onClick}>
						{button.text}
					</Card.Button>
				</div>
			)}
		</Card.BodyContainer>
		{link?.to && (
			<CardLink
				link={link.to}
				text={header || link?.text}
				className={cx(styles.secondaryLink)}
				rel="nofollow"
			/>
		)}
		{button?.to && (
			<CardLink
				link={button.to}
				text={button.text}
				className={cx(styles.secondaryLink)}
				rel="nofollow"
			/>
		)}
	</Card>
);

SecondaryCard.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}),
	header: string.isRequired,
	subheader: string,
	link: shape({
		to: string.isRequired,
		target: string,
		icon: shape({
			svg: shape({
				content: string,
			}),
		}),
		text: string,
	}),
	button: shape({
		to: string,
		onClick: func,
		target: string,
		icon: string,
		iconPlacement: oneOf(["right", "left"]),
		outline: bool,
		className: string,
		text: string,
	}),
	className: string,
	style: objectOf(oneOfType([string, number])),
	horizontal: bool,
	bodyClassNames: shape({
		cardBody: string,
	}),
};

SecondaryCard.defaultProps = {
	image: null,
	className: "",
	link: null,
	button: undefined,
	style: {},
	horizontal: false,
	subheader: null,
	bodyClassNames: {},
};

export default SecondaryCard;
export { SecondaryCard };
